import script from "./Vue3Modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Vue3Modal.vue?vue&type=script&setup=true&lang=ts"

import "./Vue3Modal.vue?vue&type=style&index=0&id=f46b8706&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.11_vue@3.5.11_typescript@5.6.3__webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f46b8706"]])

export default __exports__